import { Icons } from '@/components/Shares/Icons';
import { useLingui } from '@lingui/react';
import { AspectRatio, Box, Card, Group, Image, NumberFormatter, Text, rem } from '@mantine/core';
import { IconUserFilled } from '@tabler/icons-react';
import classes from './Aside.module.css';
export type AsideRoomItemProps = {
  title: string;
  username: string;
  imgUrl: string;
  money: number;
  userQuantity: number;
  status?: 'onGoing' | 'complete' | undefined;
  time?: string | undefined;
};
export const AsideRoomItem: React.FC<AsideRoomItemProps> = ({
  ...props
}) => {
  const {
    i18n
  } = useLingui();
  return <Card radius={5} bg="linear-gradient(103.61deg, #363D43 1.86%, #282D32 100%)" opacity={props.status === 'complete' ? 0.6 : 1}>
      <Card.Section px={10}>
        <Group justify="space-between" fz={13} c="var(--text-dark)">
          <Text inherit>{props.title}</Text>
          <Group gap={8}>
            <Text inherit>{props.username}</Text>
            <Image src="/assets/cat-avatar.png" alt="avatar" w={29} h={29} />
          </Group>
        </Group>
      </Card.Section>
      <Card.Section>
        <Group gap={0} bg="var(--bg-400)">
          <AspectRatio ratio={55 / 59}>
            <Image src={props.imgUrl} w={55} h={59} alt="game" className={props.status === 'complete' ? classes.imageGray : undefined} />
          </AspectRatio>

          <Group flex={1} px={10} justify="space-between">
            <Box>
              <Text fz={13}>{i18n._('Bonus Buy')}</Text>
              <Group align="center" gap={5}>
                <IconUserFilled size={20} />
                <Text fz="xs" fw={700} lts={rem(4)} lh={rem(20)}>
                  {`${props.userQuantity}/5`}
                </Text>
              </Group>
            </Box>

            <Box>
              <Text fw={700} fz="xs" ta="right">
                <NumberFormatter value={props.money} thousandSeparator="," prefix="$" />
              </Text>

              {props.time ? <Group gap={4} align="center">
                  <Icons className="icon-pr-flat-clock" fontSize={20} color="var(--text-dark)" />
                  <Text fz="xs" fw={700} c="var(--text-green)">
                    {props.time}
                  </Text>
                </Group> : <Text fz="xs" fw={700} c="var(--text-green)" tt="capitalize">
                  {props.status}
                </Text>}
            </Box>
          </Group>
        </Group>
      </Card.Section>
    </Card>;
};